import ContentPromoBlock from './content-promo-block'
import ContentPromoBlockQuery from './content-promo-block.query'

export { ContentPromoBlockQuery }
export default ContentPromoBlock
